export default {
    clearAavOrdersFilters: (state: any) => {
        state.queryParams = {
            page: 1,
            limit: 50,
            sortDirection: 'DESC',
            statusId: null,
            search: null,
            tags: null,
            createdAtMin: null,
            createdAtMax: null,
        };
    },
    setAavOrdersList: (state: any, action: any) => {
        state.list = action.payload;
    },
};
